import { useState, useEffect } from "react";
import "./Quick_quiz_stepform.css";
import { ProgressBar, Step } from "react-step-progress-bar";

import "react-step-progress-bar/styles.css";
import "react-circular-progressbar/dist/styles.css";

import Step_one from "./step-one/Step_one";
import Step_two from "./step-two/Step_two";
import Step_three from "./step-three/Step_three";
import Step_four from "./step-four/Step_four";
import Step_five from "./step-five/Step_five";
import Step_six from "./step-six/Step_six";
import Step_seven from "./step-seven/Step_seven";
import { useDispatch, useSelector } from "react-redux";
import {
  Brandings,
  getAllCategories,
  getAllColor,
  getAllFaceWidth,
  getAllFaceWidthShape,
  getAllFrameType,
  getAllGender,
  getAllMaterial,
  getAllShape,
} from "../../features/master/masterSlice";

const Quick_quiz_stepform = ({
  filters,
  onFilterChange,
  handleFilterReset,
}) => {
  const [page, setPage] = useState(0);

  const [category, setCategory] = useState();
  const [subPage, setSubPage] = useState(0); // State for sub-steps within Stepseven

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page, subPage]);

  const nextStep = () => {
    if (page === 5 && subPage === 0) {
      setSubPage(1); // Move to the second form within Stepseven
    } else {
      setPage((currPage) => currPage + 1);
      setSubPage(0); // Reset subPage for the next step
    }
  };

  const prevStep = () => {
    if (page === 5 && subPage === 1) {
      setSubPage(0); // Move back to the first form within Stepseven
    } else {
      setPage((currPage) => currPage - 1);
      setSubPage(0); // Reset subPage for the previous step
    }
  };

  const dispatch = useDispatch();

  const allCategories = useSelector((state) => state.master.categories);
  const allGender = useSelector((state) => state.master.all_gender);
  const allMaterial = useSelector((state) => state.master.all_material);
  const allFrameType = useSelector((state) => state.master.all_frame_type);
  const allColor = useSelector((state) => state.master.all_color);
  const allFaceWidth = useSelector((state) => state.master.all_face_width);
  const allShape = useSelector((state) => state.master.all_shape);

  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(getAllGender());

    dispatch(getAllFrameType());

    dispatch(getAllFaceWidth());
    dispatch(getAllShape());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllMaterial({ category_id: category?.id }));
    dispatch(getAllColor({ category_id: category?.id }));
  }, [dispatch, category]);

  useEffect(() => {
    handleFilterReset();
  }, []);

  const PageDisplay = () => {
    switch (page) {
      case 0:
        return (
          <Step_one
            nextStep={nextStep}
            onFilterChange={onFilterChange}
            allCategories={allCategories}
            heading={stepNames[0]}
            filters={filters}
            category={category}
            setCategory={setCategory}
          />
        );
      case 1:
        return (
          <Step_two
            nextStep={nextStep}
            onFilterChange={onFilterChange}
            allGender={allGender}
            prevStep={prevStep}
          />
        );
      case 2:
        return (
          <Step_three
            nextStep={nextStep}
            onFilterChange={onFilterChange}
            allShape={allShape}
            prevStep={prevStep}
          />
        );
      case 3:
        return (
          <Step_four
            nextStep={nextStep}
            onFilterChange={onFilterChange}
            allColor={allColor}
            prevStep={prevStep}
          />
        );
      case 4:
        return (
          <Step_five
            nextStep={nextStep}
            onFilterChange={onFilterChange}
            allMaterial={allMaterial}
            prevStep={prevStep}
          />
        );
      // case 5:
      //     return <Step_six nextStep={nextStep} onFilterChange={onFilterChange} allFaceWidth={allFaceWidth} prevStep={prevStep} />;
      // case 6:
      //     return <Step_seven nextStep={nextStep} onFilterChange={onFilterChange} prevStep={prevStep} />;
      // case 7:
      //     return <Stepnine nextStep={nextStep} prevStep={prevStep} />;
      // case 8:
      //     return <Step_seven nextStep={nextStep} prevStep={prevStep} />;
      // default:
      //     return null;
    }
  };

  const stepNames = [
    // "Business Details",
    // "product and trade ",
    // "Certification & License",
    // "GST/PAN Details",
    // "Owner Details",
    // "Bank Details",
    // "Commission & Onboarding",
  ];

  return (
    <>
      <section className="QuizStepMain">
        <div className="ProgressBar">
          <ProgressBar
            percent={(page / (stepNames.length - 1)) * 100}
            filledBackground="#0F3768"
            height="3px"
            style={{ margin: "auto" }}
          >
            {stepNames.map((name, index) => (
              <Step key={index}>
                {({ accomplished }) => (
                  <div
                    style={{
                      backgroundColor: index <= page ? "#0F3768" : "#ffffff",
                      color: index <= page ? "#fff" : "#000000",
                      border:
                        index <= page
                          ? "1px solid #0F3768"
                          : "1px solid #FFFFFF",
                      boxShadow:
                        index <= page ? "none" : "0px 0px 6px #00000029",
                    }}
                    className={`step ${index <= page ? "completed" : ""}`}
                  >
                    <p className="mb-0">{index + 1}</p>
                    <div className="step-name">{name}</div>
                  </div>
                )}
              </Step>
            ))}
          </ProgressBar>
        </div>

        <div className="userForm">
          <div className="step-Form-Container">
            <div className="container">{PageDisplay()}</div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Quick_quiz_stepform;
